import MapLibreGL from "maplibre-gl";

type Entry = {
    map: MapLibreGL.Map;
    updateRotation: () => void;
};

const registry = new Map<MapLibreGL.Map, Entry>();

function initialize(dotNetHelper: any, map: MapLibreGL.Map, compassEl: HTMLElement): void {
    const updateRotation = () => {
        const bearing = map.getBearing();
        const pitch = map.getPitch();
        compassEl.style.transform = `rotateX(${pitch}deg) rotateZ(${-bearing}deg)`;
    };

    map.on("rotate", updateRotation);
    map.on("pitch", updateRotation);
    updateRotation();

    registry.set(dotNetHelper, {
        map,
        updateRotation
    });
}

function destroy(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { map, updateRotation } = entry;

    map.off("rotate", updateRotation);
    map.off("pitch", updateRotation);

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    destroy
}